import React, { useState } from "react";

import {
  CalendarDeleteSeriesModalContent,
  ScheduleDeleteSeriesModal,
} from "./ScheduleDeleteSeriesModal";

import "./styles.scss";

const DeleteRecurringAvailableModal = ({ onCancel, onSubmit, subTitleText }) => {
  const [deleteSeries, setDeleteSeries] = useState(undefined);

  const deleteSeriesOnChange = (e) => setDeleteSeries(e.target.value);

  return (
    <ScheduleDeleteSeriesModal
      deleteSeriesValue={deleteSeries}
      disableSubmit={!deleteSeries}
      onCancel={onCancel}
      onCancelText="Keep Availability"
      onSubmit={() => onSubmit(deleteSeries)}
      subTitle={subTitleText}
      title="You're cancelling recurring custom availability"
    >
      <CalendarDeleteSeriesModalContent
        deleteSeriesOnChange={deleteSeriesOnChange}
        deleteSeriesValue={deleteSeries}
      />
    </ScheduleDeleteSeriesModal>
  );
};

export function ScheduleDeleteAvailableModal({ isRecurring, onCancel, onSubmit, subTitleText }) {
  return (
    <>
      {isRecurring && (
        <DeleteRecurringAvailableModal
          onCancel={onCancel}
          onSubmit={onSubmit}
          subTitleText={subTitleText}
        />
      )}

      {!isRecurring && (
        <ScheduleDeleteSeriesModal
          onCancel={onCancel}
          onCancelText="Keep Availability"
          onSubmit={onSubmit}
          onSubmitText="Cancel Event"
          showSubTitleOnNewLine={true}
          subTitle={subTitleText}
          title="You're cancelling custom availability"
        />
      )}
    </>
  );
}
